import React from 'react';
import styles from './ScrimSyncOverlay.module.css';

interface ScrimSyncOverlayProps {
  onSyncChange: (offsetChange: number) => void;
  isVisible: boolean;
  containerStyle?: React.CSSProperties; // Allows callers to position overlay (e.g., align to video bottom)
}

// Note: offsetChange is intentionally inverse to the label shown to users.
// Example: Clicking "+10s" advances playback by 10 seconds, which means
// we apply a -10s offset to the video's start (offsetChange = -10).
const ScrimSyncOverlay: React.FC<ScrimSyncOverlayProps> = ({
  onSyncChange,
  isVisible,
  containerStyle
}) => {
  return (
    <div className={`${styles.overlay} ${isVisible ? styles.visible : styles.hidden}`} style={containerStyle}>
      <div className={styles.syncContainer}>
        <button
          className={styles.syncButton}
          onClick={() => onSyncChange(+10)}
          title="Sync -10 seconds"
        >
          -10s
        </button>
        <button
          className={styles.syncButton}
          onClick={() => onSyncChange(+1)}
          title="Sync -1 second"
        >
          -1s
        </button>
        <div className={styles.syncLabel}>SYNC</div>
        <button
          className={styles.syncButton}
          onClick={() => onSyncChange(-1)}
          title="Sync +1 second"
        >
          +1s
        </button>
        <button
          className={styles.syncButton}
          onClick={() => onSyncChange(-10)}
          title="Sync +10 seconds"
        >
          +10s
        </button>
      </div>
    </div>
  );
};

export default ScrimSyncOverlay;
